/**
 * Created by Administrador on 06/09/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .controller('luggageRulesCtrl', luggageRulesCtrl)
        .controller('newEditLuggageRuleCtrl', newEditLuggageRuleCtrl)
        .controller('deleteLuggageRuleController', deleteLuggageRuleController);

    luggageRulesCtrl.$inject = ['linkService','luggageRules','$translate'];
    newEditLuggageRuleCtrl.$inject = ['linkService','luggageRule','segments','luggageRuleService','excessLuggageTypes'];
    deleteLuggageRuleController.$inject = ['luggageRuleId', 'luggageRule', 'luggageRuleService', '$uibModalInstance'];

    function luggageRulesCtrl(linkService,luggageRules,$translate){
        var vm = this;
        vm.linkService = linkService;

        vm.luggageRules = getLuggageRules((luggageRules.data._embedded) ? luggageRules.data._embedded.luggages : []);
        vm.pages = {};
        vm.pages = luggageRules.data.page;

        function handleLuggageSegments(segmentLuggages) {
            var luggageSegmentText = "";
            angular.forEach(segmentLuggages, function (segmentLuggage) {
                luggageSegmentText = luggageSegmentText + segmentLuggage._embedded.segment.initials + ' | ';
            });

            return {
                "name": "air.luggageRule.table.luggageRuleNames.segment",
                "data": luggageSegmentText.substring(0, luggageSegmentText.length - 2)
            };
        };

        function handleLuggageFranchises(franchiseLuggages) {
            var luggageFranchiseText = "";
            angular.forEach(franchiseLuggages, function (franchiseLuggage) {
                var passengerTypeAux = franchiseLuggage.passengerTypeId==1?'ADT ':'CHD ';
                luggageFranchiseText = luggageFranchiseText + passengerTypeAux +(franchiseLuggage.weightPerUnit * franchiseLuggage.freeFranchise) + ' kgs, ';
            });

            return {
                "name": "air.luggageRule.franchise.freeFranchise",
                "data": luggageFranchiseText.substring(0, luggageFranchiseText.length - 2)
            };
        };

        function handleLuggageExcess(excessLuggages) {
            var luggageExcessText = "";
            angular.forEach(excessLuggages, function (excessLuggage) {
                luggageExcessText = luggageExcessText + $translate.instant(excessLuggage._embedded.excessLuggageType.lang)+' '+excessLuggage.amount + ', ';
            });

            return {
                "name": "air.luggageRule.excess.luggageExcess",
                "data": luggageExcessText.substring(0, luggageExcessText.length - 2)
            };
        };

        function handleLuggageRules(regulation) {
            var handleLuggageRules = [];
            handleLuggageRules.push(handleLuggageSegments(regulation.segmentLuggages));
            handleLuggageRules.push(handleLuggageFranchises(regulation.franchiseLuggages));
            handleLuggageRules.push(handleLuggageExcess(regulation.excessLuggages));
            return handleLuggageRules;
        };

        function getLuggageRules(luggageRules){
            angular.forEach(luggageRules, function(luggageRule){
                luggageRule.handleLuggageRules = handleLuggageRules(luggageRule._embedded);
            });
            return luggageRules;
        }
    };

    function newEditLuggageRuleCtrl(linkService,luggageRule,segments,luggageRuleService,excessLuggageTypes){
        var vm = this;
        vm.linkService = linkService;

        vm.luggageRule = {
            active: false,
            segments: [],
            rbcFranchiseLuggages: [
                {
                    passengerTypeId : 1,
                    code: 'ADT',
                    weightPerUnit: null,
                    freeFranchise: null,
                    maximumFranchise:null,
                    translateType:'air.passengerType.adult'
                },
                {
                    passengerTypeId : 27,
                    code: 'CHD',
                    weightPerUnit: null,
                    freeFranchise: null,
                    maximumFranchise:null,
                    translateType:'air.passengerType.child'
                }
            ],
            rbcExcessLuggages: []
        };
        vm.segments =  (segments.data) ? segments.data._embedded.segments : [];

        var urlTemplateBase = "app/admin/configGeneral/rates/luggageRule/templates/";
        vm.luggageRuleTemplates = [
            {
                name: "segment",
                template: urlTemplateBase + "segmentLuggageRule/segmentLuggageRule.html"
            },
            {
                name: "franchise",
                template: urlTemplateBase + "franchiseLuggageRule/franchiseLuggageRule.html"
            },
            {
                name: "excess",
                template: urlTemplateBase + "excessLuggageRule/excessLuggageRule.html"
            }
        ];

        vm.checkBoxSegment = {};
        vm.calcTypes = excessLuggageTypes;

        vm.eventHandleSegment = function(){
            var j = 0;
            angular.forEach(vm.checkBoxSegment, function (i, val) {
                if(i == false || i == undefined){
                    vm.luggageRule.segments[j].select = false;
                }else if (i == true){
                    vm.luggageRule.segments[j].select = true
                }
                j++;
            });
        }

        vm.getSegments = function(auxSegments){
            angular.forEach(vm.segments, function(segment){
                var flagSegment = false;
                if(auxSegments.length > 0){
                    flagSegment = thereSegment(auxSegments, segment);
                }
                vm.luggageRule.segments.push({
                    id: 0,
                    initials: segment.initials,
                    originAirportId: segment.originAirportId,
                    destinyAirportId: segment.destinyAirportId,
                    select: flagSegment
                });
                vm.checkBoxSegment[segment.initials] = flagSegment;
            });
        }

        function thereSegment(segments, segment){
            var res = false;
            for(var i = 0; i < segments.length; i++){
                if(segment.originAirportId == segments[i]._embedded.segment.originAirportId
                    && segment.destinyAirportId == segments[i]._embedded.segment.destinyAirportId){
                    res = true;
                    break;
                }
            }
            return res;
        }

        function loadObject(luggageRule){
            if(luggageRule != null){
                vm.action = 'edit';
                vm.luggageRule.active = luggageRule.data.active;
                vm.luggageRule.name = luggageRule.data.name;
                vm.luggageRule.nameLang = luggageRule.data.nameLang;
                vm.luggageRule.description = luggageRule.data.description;
                vm.luggageRule.luggageRuleId = vm.linkService.getLinkId(luggageRule.data._links.self.href);
                vm.luggageRule.rbcFranchiseLuggages = luggageRule.data._embedded.franchiseLuggages;
                vm.luggageRule.rbcExcessLuggages = luggageRule.data._embedded.excessLuggages;
                vm.getSegments(luggageRule.data._embedded.segmentLuggages);
                setPassengerType(vm.luggageRule.rbcFranchiseLuggages);
            }else{
                vm.action = 'new';
                vm.getSegments([]);
            }
        }

        vm.saveLuggageRule = function(isValid, luggageRule){
            if(isValid){
                vm.luggageRule.rbcSegmentLuggages = getSegmentsData(vm.luggageRule.segments);
                if(vm.action == "new"){
                    luggageRuleService.saveLuggageRule(vm.luggageRule);
                }else{
                    luggageRuleService.updateLuggageRule(vm.luggageRule.luggageRuleId, vm.luggageRule);
                }
            }
        }

        loadObject(luggageRule);
    }

    function deleteLuggageRuleController(luggageRuleId, luggageRule, luggageRuleService, $uibModalInstance) {
        var vm = this;

        vm.name = luggageRule.data.name;

        vm.deleteLuggageRule = function () {
            luggageRuleService.deleteLuggageRule(luggageRuleId)
                .then(function () {
                    $uibModalInstance.close(true);
                })
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

    function getSegmentsData(segments){
        var res = [];
        angular.forEach(segments, function (segment) {
            if (segment.select == true) {
                res.push({
                    originAirportId: segment.originAirportId,
                    destinyAirportId: segment.destinyAirportId
                });
            }
        });
        return res;
    }

    function setPassengerType(rbcFranchiseLuggages){
        var res = [];
        angular.forEach(rbcFranchiseLuggages, function (franchiseLuggage) {
            if (franchiseLuggage.passengerTypeId == 1) {
                franchiseLuggage.translateType = 'air.passengerType.adult';
                franchiseLuggage.code = 'ADT';
            }else{
                franchiseLuggage.translateType = 'air.passengerType.child';
                franchiseLuggage.code = 'CHD';
            }
        });
        return res;
    }
})();
